import { useState } from 'react'
import s from './styles.module.scss'

const Previewer = ({ url, documentString, iframeWidth, iframeHeight, fullWidth, showText, hideText }: any) => {
    const [showPreview, setShowPreview] = useState(false)

    const buttonLabel = showText && hideText
        ? (showPreview ? hideText : showText)
        : `Click here to show/hide your ${documentString && documentString.length ? documentString : 'document'} preview`

    return (
        <div style={fullWidth ? { width: '100%' } : undefined}>
            <button onClick={() => setShowPreview(!showPreview)} className={s.previewLink}>
                {buttonLabel}
            </button>
            <div className={fullWidth
                ? `${s.previewerFullWidth} ${showPreview ? s.show : ''}`
                : `${s.previewer} ${showPreview ? s.show : ''}`
            }>
                <iframe
                    title="preview-item"
                    src={url}
                    height={iframeHeight ?? 450}
                    width={fullWidth ? '100%' : (iframeWidth ?? 300)}
                    style={fullWidth ? { width: '100%', height: iframeHeight ?? 700 } : undefined}
                />
            </div>
        </div>
    )
}
export default Previewer
